<template>
    <div>
        <iframe :name='element.name' :src="element.options.src" :frameborder="element.options.frameborder" :width="element.options.width" :height="element.options.height" :scrolling='element.options.scrolling' :marginheight='element.options.marginheight' :marginwidth='element.options.marginwidth'></iframe>
    </div>
</template>

<script>
export default {
    name:'iframeComponents',
    props:['element'],
    data(){
        return{

        }
    },
    computed: {
        //当前详情页信息
        detailInfos() {
            return this.$store.state.detailInfo
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
        //子表信息
        currentAppChildRowData(){
            return this.$store.state.currentAppChildRowData
        },
        //是否请求子表数据
        isrequestChildTableData(){
            return this.$store.state.isrequestChildTableData
        }
    },
    methods:{

    }
}
</script>

<style>

</style>